module.exports = "<div class=\"component-details\" ng-transclude></div>\n";